import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { AppointmentsRootState } from '../reducers/appointments';
import { Appointment } from '../../models';
import AppointmentRepository from '../../repositories/AppointmentRepository';

export const ADD_APPOINTMENT = 'ADD_APPOINTMENT';
export const REQUEST_APPOINTMENTS = 'REQUEST_APPOINTMENTS';
export const RECEIVE_APPOINTMENTS = 'RECEIVE_APPOINTMENTS';
export const SHOW_APPOINTMENT_DETAIL = 'SHOW_APPOINTMENT_DETAIL';
export const SET_SIDEP = 'SET_SIDEP';
export const SET_OPTIONAL_FORM_DATA = 'SET_OPTIONAL_FORM_DATA';
export const RESET_OPTIONAL_FORM_DATA = 'RESET_OPTIONAL_FORM_DATA';
export const SET_APPOINTMENT = 'SET_APPOINTMENT';
export const SUBMIT_APPOINTMENT = 'SUBMIT_APPOINTMENT';
export const RESET_APPOINTMENT = 'RESET_APPOINTMENT';
export const SET_LOADING = 'SET_LOADING';
export const RESET = 'RESET';

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppointmentsRootState,
  unknown,
  Action<string>
>;

export function addAppointment(id: number): AppThunk {
  return (dispatch) => {
    dispatch({
      type: ADD_APPOINTMENT,
      id
    });
  };
}

export function setAppointment(appointment: Partial<Appointment>): AppThunk {
  return (dispatch) => {
    dispatch({
      type: SET_APPOINTMENT,
      appointment
    });
  };
}

export function submitAppointment(
  params: { partnershipId?: string | null } = {}
): AppThunk {
  return (dispatch, getState) => {
    dispatch({
      type: SET_LOADING,
      value: true
    });

    let newAppointment = new Appointment({
      ...(getState() as any).appointments.appointment,
      partnershipId: params.partnershipId
    });

    return AppointmentRepository.create(newAppointment)
      .then((appointment) => {
        return appointment;
      })
      .finally(() => {
        dispatch({
          type: SET_LOADING,
          value: false
        });
      });
  };
}

export function showAppointmentDetail(id: number): AppThunk {
  return (dispatch) => {
    dispatch({
      type: SHOW_APPOINTMENT_DETAIL,
      id
    });
  };
}

export function requestAppointments(query: string) {
  return {
    type: REQUEST_APPOINTMENTS,
    query
  };
}

export function receiveAppointments(json: JSON) {
  return {
    type: RECEIVE_APPOINTMENTS,
    activities: json,
    receivedAt: Date.now()
  };
}

export function resetAppointment() {
  return {
    type: RESET
  };
}

export function fetchAppointments(query: string): AppThunk {
  return (dispatch) => {
    dispatch(requestAppointments(query));
    return fetch(`/data/activities.json`)
      .then((response) => response.json())
      .then((json) => dispatch(receiveAppointments(json)));
  };
}

export function setSidep(key: string, value: unknown): AppThunk {
  return (dispatch) => {
    dispatch({
      type: SET_SIDEP,
      key,
      value
    });
  };
}

export function setOptionalFormData(
  key: string,
  data: {
    key: string;
    label: string;
    value: any;
  }[]
): AppThunk {
  return (dispatch) => {
    dispatch({
      type: SET_OPTIONAL_FORM_DATA,
      key,
      data
    });
  };
}

export function resetOptionalFormData(): AppThunk {
  return (dispatch) => {
    dispatch({
      type: RESET_OPTIONAL_FORM_DATA
    });
  };
}
